import React, { ReactNode } from "react";
import backgroundImg from "./../../images/x-p0.png";

interface PageHeaderSectionProps {
  id?: string;
  headline: string; // Der Haupttitel (h4)
  subheadline: string; // Der Untertitel
  content?: ReactNode; // Zusätzlicher Inhalt unterhalb des Headers
  style?: React.CSSProperties;
}

const PageHeaderSection: React.FC<PageHeaderSectionProps> = ({
  id = "",
  headline,
  subheadline,
  content,
  style,
}) => {
  const containerStyle: React.CSSProperties = {
    position: "relative",
    textAlign: "center",
    padding: "3rem 1rem",
  };

  const clipartStyle: React.CSSProperties = {
    content: "''",
    background: `url(${backgroundImg}) no-repeat center center`,
    display: "block",
    position: "absolute",
    width: "192px",
    height: "140px",
    top: 0,
    right: 0,
    left: 0,
    margin: "auto",
    zIndex: -1,
  };

  const headlineStyle: React.CSSProperties = {
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "24px",
    textAlign: "center",
    letterSpacing: ".25em",
    display: "block",
    padding: 0,
    marginBottom: "10px",
    textTransform: "uppercase",
    color: "#c39d63",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const subheadlineStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Ultralight",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "64px",
    lineHeight: "62px",
    textAlign: "center",
    letterSpacing: ".03em",
    textTransform: "capitalize",
    color: "#514633",
    display: "block",
    marginBottom: "65px",
    wordWrap: "break-word",
  };

  return (
    <section style={{...containerStyle, ...style}} id={id}>
      {/* Clipart im Hintergrund */}
      <div style={clipartStyle}></div>
      {/* Headline */}
      <h4 style={headlineStyle}>{headline}</h4>
      {/* Subheadline */}
      <div style={subheadlineStyle}>{subheadline}</div>
      {/* Zusätzlicher Content */}
      {content && <div>{content}</div>}
    </section>
  );
};

export default PageHeaderSection;
